import { createContext, useContext, useEffect, useState } from "react";
import Globals from "../services/Globals";

interface GlobalContextProps {
    UNDERCONSTRUCTION: boolean;
    DevEnabled: boolean;
    DebugEnabled: boolean;
    Strings: any;
    GlobalImagesVersion: string;
    BANNER_COLOR: string;
    SetLanguage: Function;
    Refresh: Function;
    OUT_EMAIL: string;
    WHATSAPP: string;
    FOOTER_TEXT: string;
    FOOTER_TEXT_COLOR: string;
    FOOTERHEADERBGCOLOR: string;
    TakenSites: string[];
}

const langFile = `${process.env.PUBLIC_URL}/lang.json`;
const GlobalContext = createContext<GlobalContextProps>({} as GlobalContextProps);

export const useGlobalContextContext = () => {
    const context = useContext(GlobalContext);
    if (context === undefined) {
        throw new Error("Custom context GlobalContext must be used within a CustomContextProvider");
    }
    return context;
};

export class OrientationValues {
    portraid: number;
    landscape: number;
}

export const GlobalContextProvider: React.FC = ({ children }) => {
    const [langJson, SetlangJson] = useState<any>();
    const [Strings, SetStrings] = useState<any>();
    const [GlobalImagesVersion, SetGlobalImagesVersion] = useState<string>("1");
    const [BANNER_COLOR, SetBANNER_COLOR] = useState<string>("white");
    const [OUT_EMAIL, SetOUT_EMAIL] = useState<string>("contact@collectietekoop.nl");
    const [WHATSAPP, SetWHATSAPP] = useState<string>("+316");
    const [FOOTER_TEXT, SetFOOTER_TEXT] = useState<string>("*.Collectietekoop.nl");
    const [FOOTER_TEXT_COLOR, SetFOOTER_TEXT_COLOR] = useState<string>("white");
    const [FOOTERHEADERBGCOLOR, SetFOOTERHEADERBGCOLOR] = useState<string>("chocolate");
    const [TakenSites, settakensites] = useState<string[]>([]);

    let DevEnabled = Globals.GetParam('dev') ? true : false;
    let DebugEnabled = Globals.GetParam('debug') ? true : false;
    let UNDERCONSTRUCTION = true;

    if (document.location.origin === "http://localhost:3000") {
        DevEnabled = true;
        DebugEnabled = true;
        UNDERCONSTRUCTION = false;
    }

    useEffect(() => {
        window.addEventListener('resize', onResize);

        (async function fetchConfig() {
            try {
                const resp = await (await fetch(langFile)).json();
                SetlangJson(resp);
                SetStrings(resp.Nederlands);
            } catch (e) {
                console.log(e);
            }
        }());

        settakensites(["retrogames","pokemon"]);
    }, []);

    function onResize() {
        console.log("resizing");
    }

    const SetLanguage = (language: string) => {
        if (langJson) {
            SetStrings(langJson[language]);
        }
    }

    const Refresh = () => {
        window.location.href = window.location.href+"?r=1";
    }

    return (
        <GlobalContext.Provider value={{
            UNDERCONSTRUCTION,
            DevEnabled,
            DebugEnabled,
            Strings,
            GlobalImagesVersion,
            BANNER_COLOR,
            SetLanguage,
            Refresh,
            OUT_EMAIL,
            WHATSAPP,
            FOOTER_TEXT,
            FOOTER_TEXT_COLOR,
            FOOTERHEADERBGCOLOR,
            TakenSites
        }}>
            {children}
        </GlobalContext.Provider>
    );
};

export default GlobalContext;